import React from 'react'
import { useS4LContext } from '@s4l/react-context'

import styles from './styles.module.css'
import { IconWarning } from '@s4l/icons/IconWarning'

export interface IGuestRoomListStatusProps {
  isEnabled: boolean
  children: React.ReactNode
}

const VoucherGuestRoomListStatus = ({ children, isEnabled }: IGuestRoomListStatusProps) => {
  const { i18n } = useS4LContext()

  if (!isEnabled) {
    return null
  }

  return (
    <div className={styles.container}>
      <p className={styles.statusContainer}>
        <span>
          {i18n.formatMessage({
            id: 'global.guest-details',
          })}
        </span>

        <span className={styles.status}>
          <IconWarning size={16} data-testid="guest-room-list-status-icon" />
          {i18n.formatMessage({
            id: `global.pending`,
          })}
        </span>
      </p>
      {children}
    </div>
  )
}

export default VoucherGuestRoomListStatus
